import { ApiError, AUTH_EXPIRED_EVENT } from "./client";

export interface UploadItem {
  fileName: string;
  status: "registered" | "duplicate" | "unsupported" | "too_large" | "empty";
  documentId?: number;
  version?: number;
  supersedesId?: number;
  message?: string;
}

export interface UploadResult {
  items: UploadItem[];
  registered: number;
}

export interface UploadMeta {
  companyId?: number | undefined;
  docTypeId?: number | undefined;
  title?: string | undefined;
  regNumber?: string | undefined;
  docDate?: string | undefined;
  mulberryId?: string | undefined;
}

/** multipart upload with progress (fetch has no upload progress events). */
export function uploadDocuments(
  files: File[],
  meta: UploadMeta,
  onProgress: (fraction: number) => void,
): Promise<UploadResult> {
  const form = new FormData();
  for (const [k, v] of Object.entries(meta)) {
    if (v !== undefined && v !== null && v !== "") form.append(k, String(v));
  }
  for (const f of files) form.append("files", f, f.name);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/api/documents");
    xhr.setRequestHeader("x-requested-with", "fetch");
    xhr.setRequestHeader("accept", "application/json");
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total);
    };
    xhr.onerror = () => reject(new ApiError(0, "network", "network error"));
    xhr.onload = () => {
      let payload: unknown = null;
      try {
        payload = JSON.parse(xhr.responseText);
      } catch {
        payload = null;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(payload as UploadResult);
      } else {
        const err = (payload as { error?: { code?: string; message?: string } } | null)?.error;
        // Same as api(): an expired session sends the user to the login page.
        if (xhr.status === 401) window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
        reject(
          new ApiError(
            xhr.status,
            err?.code ?? `http_${xhr.status}`,
            err?.message ?? xhr.statusText,
          ),
        );
      }
    };
    xhr.send(form);
  });
}
